import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useBlankStateButtons } from './useBlankStateButtons'

export type BlankStatePromptTypes =
  | 'manager_to_employee'
  | 'employee_to_manager'
  | 'employee_to_employee'
  | 'manager_to_team'
  | 'employee_to_manager_team'

interface BlankStateProps {
  employeeName: string
  onPromptClick: (content: string) => void
  type?: BlankStatePromptTypes
}

export const BlankState = ({
  employeeName,
  onPromptClick,
  type = 'manager_to_employee',
}: BlankStateProps) => {
  const { employee: currentEmployee } = useCurrentSession()
  const buttons = useBlankStateButtons(employeeName, type)

  return (
    <Box width="full" alignItems="flexStart" height="full">
      <Box paddingX="s16">
        <Text.Normal color="grey600" size="300" weight="medium">
          {i18n.t('common.ai.greeting', { name: currentEmployee?.firstName })}
        </Text.Normal>
        <Text.Normal color="grey1000" weight="semibold" size="400">
          {i18n.t('common.ai.initial')}
        </Text.Normal>
      </Box>
      <Box paddingTop="s32" flexDirection="column" alignItems="flexStart" gap="s4">
        {buttons.map((button) => (
          <F0Button
            key={button.label}
            label={button.label}
            onClick={() => onPromptClick(button.content)}
            variant="ghost"
            icon={button.icon}
          />
        ))}
      </Box>
    </Box>
  )
}
